import React, { Component } from 'react';
import { observer } from 'mobx-react';
import 'Styles/otherSettings/restrictionSelectModal.scss';
import OtherSettingsStore from 'Stores/otherSettingsStore';
import Checkbox from "Components/Common/checkbox";
import Helper from 'Utils/Helper';

class RestrictionSelectModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let splitByCount = 9;
        let isMultiColumn = OtherSettingsStore.restrictions.length > splitByCount;
        let restrictionPanelClass =
            "restriction-panel "
            + (isMultiColumn
                ? "restriction-panel-multicolumn"
                : "restriction-panel-singlecolumn"
            )
            ;

        let restrictionsBlocks = isMultiColumn ? Helper.ArrayChunk(OtherSettingsStore.restrictions, splitByCount) : [OtherSettingsStore.restrictions];

        return (
            <div className="restrictions-panels-holder overflowing-element">
                {restrictionsBlocks.map(restrictionsBlock => (
                    <div className={restrictionPanelClass}
                        key={`panel-${restrictionsBlock[0]?.id}`}>
                        {restrictionsBlock.map(restriction => (
                            <div className="restriction-checkbox-line"
                                key={`rcl-${restriction.id}`}>
                                <Checkbox
                                    checked={OtherSettingsStore.selectedRestrictionsIds.some(id => id == restriction.id)}
                                    onChange={checked => {
                                        if (checked) {
                                            OtherSettingsStore.selectedRestrictionsIds.push(restriction.id);
                                        }
                                        else {
                                            OtherSettingsStore.selectedRestrictionsIds = OtherSettingsStore.selectedRestrictionsIds.filter(id => id != restriction.id);
                                        }
                                    }} />
                                <div className={`restriction-checkbox-value ${restriction.deleted ? 'restriction-deleted' : ''}`} >
                                    {`${restriction.value} ${(restriction.deleted ? ' (логически удален)' : '')}`}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        )
    }
}

export default observer(RestrictionSelectModal);